module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("\n    Normalized miner income for work done (DARI)\n  ")]), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(1, false, false), _vm._v(" "), _vm._m(2, false, false), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n    With this result we can compare the two chains. For example, using the DARI of the last block we can estimate that a " + _vm._s(_vm.leader) + " miner could potentially collect (" + _vm._s(_vm.dari(_vm.leader)) + " / " + _vm._s(_vm.dari(_vm.loser)) + " =)\n    "), _c('strong', [_vm._v(_vm._s(_vm.leader_ratio))]), _vm._v(" times the reward (in USD) that a " + _vm._s(_vm.loser) + " miner could collect.\n  ")]), _vm._v(" "), _vm._m(3, false, false), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-pills justify-content-center small"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'reward.dari.btc'
      }
    }
  }, [_vm._v("BTC")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'reward.dari.bch'
      }
    }
  }, [_vm._v("BCH")])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view', {
    key: _vm.$route.fullPath
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%",
      "width": "100%"
    }
  }, [_c('canvas', {
    staticStyle: {
      "height": "512px"
    },
    attrs: {
      "id": "canvas-dari"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n    The DARI (Difficulty Adjusted Reward Index) is a way to compare the rewards of two chains that share the same reward system. The following calculation is used to determine the DARI:\n    "), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('code', [_vm._v("\n      (block coinbase+fees in satoshis) / (block difficulty) * (exchange rate in USD)\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n    Since the inception of BCH we have seen that some miners switch based on which coin is most rewarding for the work they perform.\n    The data below is an attempt to capture some of the effects of this so called \"chain hopping\".\n    "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n    Whether the chain hopping actually results in more income for a miner depends on many factors. Most notably the pool\n    "), _c('a', {
    attrs: {
      "href": "https://en.bitcoin.it/wiki/Comparison_of_mining_pools",
      "target": "_blank"
    }
  }, [_vm._v("reward type")]), _vm._v(", the exchange rate\n    (since coins need to mature 100 blocks before they can be spent), the cash out strategy of the miner and of course plain old luck :)\n  ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f4bcb29","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/charts/dari.vue
// module id = 546
// module chunks = 1